import {log} from "./logEvent";

export default function() {
    const fields = {};
    if (window.screen) {
        fields.screen_width = window.screen.width;
        fields.screen_height = window.screen.height;
    }
    if (Intl) {
        fields.time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    log("ApplicationLoaded", fields);
};
